var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3771 4.22486L12.0522 3.96762C11.1429 3.24777 9.85799 3.24777 8.9487 3.96762L8.62146 4.22294L2.32839 9.20752C2.15128 9.34781 2.11824 9.60368 2.25391 9.78435L2.77532 10.4787C2.91645 10.6666 3.18498 10.7007 3.36859 10.554L3.83379 10.1823V16.0725C3.83379 17.4532 4.95308 18.5725 6.3338 18.5725L9.24801 18.5725L9.25046 18.5725L14.6671 18.5725C16.0478 18.5725 17.1671 17.4532 17.1671 16.0725V10.183L17.6315 10.554C17.8151 10.7007 18.0837 10.6666 18.2248 10.4787L18.7462 9.78435C18.8819 9.60368 18.8488 9.34781 18.6717 9.20752L15.5005 6.69565V4.75011C15.5005 4.51999 15.3139 4.33345 15.0838 4.33345H14.2505C14.0203 4.33345 13.8338 4.51999 13.8338 4.75011V5.37553L12.3786 4.22294L12.3771 4.22486ZM5.50046 9.22635V16.0725C5.50046 16.5327 5.87356 16.9058 6.3338 16.9058L8.83379 16.9058V13.0834C8.83379 12.8533 9.02034 12.6668 9.25046 12.6668H11.7505C11.9806 12.6668 12.1671 12.8533 12.1671 13.0834V16.9058L14.6671 16.9058C15.1274 16.9058 15.5005 16.5327 15.5005 16.0725V9.22635C15.5005 9.03492 15.4347 8.85139 15.3172 8.70492L11.0177 5.27436C10.7146 5.03441 10.2863 5.03441 9.98321 5.27436L5.6852 8.7031C5.5668 8.84987 5.50046 9.03413 5.50046 9.22635Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4da23b8208a8c28c5da308f11b126620.svg";
export { ForwardRef as ReactComponent };